import { render, staticRenderFns } from "./ResultsCard.vue?vue&type=template&id=2c52d9ca&scoped=true&"
import script from "./ResultsCard.vue?vue&type=script&lang=js&"
export * from "./ResultsCard.vue?vue&type=script&lang=js&"
import style0 from "./ResultsCard.vue?vue&type=style&index=0&id=2c52d9ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c52d9ca",
  null
  
)

export default component.exports